import { Trans } from "../utils/i18n";
import Cookies from "js-cookie";
import React from "react";
import {validateEmailRegEx, validatePhoneNumber} from "../Shared/FormField";
import {t} from "i18next";
import DeviceWidget from "../FormComponents/DeviceWidget/DeviceWidget";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import MuiPhoneNumber from "material-ui-phone-number";
import {formatCurrency} from "../utils/formatCurrency";
import {hasProducts} from "./orderEntryNiu";
import { Button } from "../Shared/Button";
import { trackConversion } from "../utils/analytics";
import getUsStates from "../utils/getUsStates";

const validProblem = (values, orderEntryState) => {
    const selectedCategory = orderEntryState && orderEntryState.selectedCategory;

    const currentProblem = selectedCategory && selectedCategory.problems.find(item => parseInt(values.problem_1) === item.id);
    const currentProblem2 = currentProblem && currentProblem.problems?.find(item => parseInt(values.problem_2) === item.id);

    return values.problem_1 && values.problem_2 && !currentProblem2?.education_text;
};

const isShowingProductSelection = (values, orderEntryState, currentCountry) => {
    if (currentCountry !== 'US' && currentCountry !== 'FR' && currentCountry !== 'DE' && currentCountry !== 'IT' && currentCountry !== 'ES' && currentCountry !== 'GB' && orderEntryState?.selectedCategory?.name !== '1004') {
        return true;
    }
    
    // TODO: Define condition
    if (currentCountry === 'US') {
        return ["1001", "1002", "1005", "1006", "1007", "1008"].includes(orderEntryState?.selectedCategory?.name);
    }

    return ["1005", "1006", "1007", "1008"].includes(orderEntryState?.selectedCategory?.name);
};

export const orderEntryConfigAmazon = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "enableStepper": true,
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "groups": [
        {
            "showSteps": false,
            "heading": <Trans i18nKey="orderEntry.repairDetails">Repair Details</Trans>,
            "description": <Trans i18nKey="orderEntry.problemDescription.description">Tell us about the problem. Select a category to continue</Trans>,
            "id": "problem_description",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.productCategory.heading'}>What kind of device do you have?</Trans></h2>
                    </>,
                },
                {
                    "size": "full",
                    "component": "productcategoryselect",
                    "fetchWithProducts": true,
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.productTypeSelection.heading'}>Please choose a product</Trans></h2>
                    </>,
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        return isShowingProductSelection(values, orderEntryState, currentCountry);
                    },
                },
                {
                    "size": "full",
                    "component": "productcategoryproductselect",
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        return isShowingProductSelection(values, orderEntryState, currentCountry);
                    },
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.purchaseDateSelection.heading'}>When did you purchase the device?</Trans></h2>
                    </>,
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        return isShowingProductSelection(values, orderEntryState, currentCountry) && !!orderEntryState?.selectedCategoryProduct && orderEntryState?.selectedCategory?.name !== '1008';
                    },
                },
                {
                    "size": "full",
                    "component": "purchasedateselect",
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        return isShowingProductSelection(values, orderEntryState, currentCountry) && !!orderEntryState?.selectedCategoryProduct && orderEntryState?.selectedCategory?.name !== '1008';
                    },
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.problem.heading'}>What happend?</Trans></h2>
                        <p><Trans i18nKey="orderEntry.problemDescription.description">Tell us about the problem. Select a category to continue</Trans></p>
                    </>,
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        const { environment } = usePage().props;

                        if (isShowingProductSelection(values, orderEntryState, currentCountry)) {
                            return orderEntryState?.selectedCategoryProduct && orderEntryState?.selectedPurchaseDate && orderEntryState?.selectedCategory?.name !== '1008';
                        }

                        if (orderEntryState?.selectedCategory?.name === '1004') {
                            return false;
                        }

                        return orderEntryState?.selectedCategory
                    },
                },
                {
                    "size": "full",
                    "component": "problemselectbig",
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        const { environment } = usePage().props;

                        if (isShowingProductSelection(values, orderEntryState, currentCountry)) {
                            return orderEntryState?.selectedCategoryProduct && orderEntryState?.selectedPurchaseDate && orderEntryState?.selectedCategory?.name !== '1008';
                        }

                        if (orderEntryState?.selectedCategory?.name === '1004') {
                            return false;
                        }

                        return false
                    },
                    "hideProblemInput": true,
                    "hideEducationText": true,
                },
                {
                    "size": "full",
                    "component": "problemselectbig",
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        const { environment } = usePage().props;

                        if (isShowingProductSelection(values, orderEntryState, currentCountry)) {
                            return false;
                        }

                        if (orderEntryState?.selectedCategory?.name === '1004') {
                            return false;
                        }

                        return orderEntryState?.selectedCategory
                    },
                    "hideProblemInput": true,
                    "hideEducationText": false,
                },

                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.whatIsYourProduct'}>What is your product?</Trans></h2>
                    </>,
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        return isShowingProductSelection(values, orderEntryState, currentCountry) && orderEntryState?.selectedCategoryProduct?.number === 'other1008';
                    },
                },
                {
                    "name": "otherProduct",
                    "label": <Trans i18nKey="orderEntry.otherProduct">Please enter your product</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.otherProduct">Please enter your product</Trans>,
                    "size": "half",
                    "type": "text",
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        return isShowingProductSelection(values, orderEntryState, currentCountry) && orderEntryState?.selectedCategoryProduct?.number === 'other1008';
                    },
                },
                {
                    "size": "half",
                    "component": "button",
                    "text": "OK",
                    "onClick": (values, orderEntryState, orderEntryDispatch) => {
                        trackConversion({
                            action: 'OrderEntryClickOtherProduct:'+(values.otherProduct),
                            resourceId: orderEntryState?.selectedCategoryProduct?.id,
                            resourceType: 'App\\Models\\Product'
                        });
                        orderEntryDispatch({
                            type: 'setOtherProductConversionButton',
                            value: true,
                        });
                    },
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        return isShowingProductSelection(values, orderEntryState, currentCountry) && orderEntryState?.selectedCategoryProduct?.number === 'other1008';
                    },
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <div className={'flex justify-center items-center w-full mt-6'}>
                            <div className={"py-6 px-9 rounded-2xl shadow-lg min-w-lg text-center bg-red-100"}>
                                <h3 className={'h3 text-center'}>
                                    <Trans i18nKey="orderEntry.outOfScope.message">Sorry, device with this problem are not currently eligible; we are working to increase the problems eligible for repair. At this time you need to contact Amazon Support. By clicking on this link you will be redirected to an external website.</Trans>
                                </h3>
                                <a className={'underline text-black mt-1.5 text-sm'} href={'https://www.amazon.co.uk/gp/help/customer/display.html'} target={'_blank'}>
                                    https://www.amazon.co.uk/gp/help/customer/display.html
                                </a>
                            </div>
                        </div>
                    </>,
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        return isShowingProductSelection(values, orderEntryState, currentCountry) && (!!orderEntryState?.selectedCategoryProduct && orderEntryState?.selectedCategory?.name === '1008' && !orderEntryState?.selectedCategoryProduct?.number?.startsWith('other')) || (orderEntryState?.selectedCategoryProduct?.number?.startsWith('other') && !!orderEntryState?.otherProductConversionButton);
                    },
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 className={'text-center text-3xl font-bold mt-16 mb-0'}><Trans i18nKey={'home.amazon.selfRepairServices'}>Self Repair Services</Trans></h2>
                        <div className={"relative mt-8 grid grid-cols-12 gap-6 w-full"}>
                            <div className={'col-span-12 md:col-span-6 flex justify-center'}>
                                <div className={'flex flex-col items-center rounded-2xl bg-[#F4F9FF] w-full max-w-[264px]'}>
                                    <img src={'/images/amazon/home_spare-parts.png'}
                                        className={'rounded-t-2xl border-[#A4D9FB] border-b-4 w-full'}/>
                                    <div className={'p-6 text-center flex flex-col items-center flex-1'}>
                                        <p className={'text-xl font-bold  mb-0'}>
                                            <Trans i18nKey={"home.amazon.selfRepair.buySpareParts"}>
                                                Buy Spare Parts
                                            </Trans>
                                        </p>
                                        <p className={'my-3 font-regular flex-1'}>
                                            <Trans i18nKey={"home.amazon.selfRepair.buySpareParts.description"}>
                                                Buy Genuine Parts
                                            </Trans>
                                        </p>
                                        <InertiaLink
                                            className={'no-underline text-sm font-bold bg-[#2A5B97] text-white rounded-md px-6 py-3 hover:bg-[#2A5B97]/70'}
                                            href={route('partsshop.index')}
                                        >
                                            <Trans i18nKey={"home.amazon.selfRepair.buySpareParts.cta"}>
                                                Buy Spare Parts
                                            </Trans>
                                        </InertiaLink>
                                    </div>
                                </div>
                            </div>
                            <div className={'col-span-12 md:col-span-6 flex justify-center'}>
                                <div className={'flex flex-col items-center rounded-2xl bg-[#F4F9FF] w-full max-w-[264px]'}>
                                    <img src={'/images/amazon/home_download.png'}
                                        className={'rounded-t-2xl border-[#A4D9FB] border-b-4 w-full'}/>
                                    <div className={'p-6 text-center flex flex-col items-center flex-1'}>
                                        <p className={'text-xl font-bold  mb-0'}>
                                            <Trans i18nKey={"home.amazon.selfRepair.downloadDocumentation"}>
                                                Download Documentation
                                            </Trans>
                                        </p>
                                        <div className={'my-3 font-regular flex-1'}>
                                        <Trans i18nKey={"home.amazon.selfRepair.downloadDocumentation.description"}>
                                            Self Repair Documentation
                                        </Trans>
                                        </div>
                                        <InertiaLink
                                            className={'no-underline text-sm font-bold bg-[#2A5B97] text-white rounded-md px-6 py-3 hover:bg-[#2A5B97]/70'}
                                            href={route('selfrepair.documentation.index')}
                                        >
                                            <Trans i18nKey="home.amazon.selfRepair.downloadDocumentation.cta">
                                                Download Documentation
                                            </Trans>
                                        </InertiaLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>,
                    "conditionFunction": (values, orderEntryState) => {
                        const { environment } = usePage().props;

                        return orderEntryState?.selectedCategory?.name === '1004';
                    },
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <div className={'flex justify-center items-center w-full mt-6'}>
                            <div className={"py-6 px-9 rounded-2xl shadow-lg min-w-lg text-center bg-red-100"}>
                                <span className={'text-center'}>
                                    <Trans getRaw i18nKey="orderEntry.outOfScopeWarranty.message"><b>Your device may still be warranted under the Amazon Device Warranty.</b> For further information, please <a href="https://www.amazon.co.uk/gp/help/customer/display.html?ref_=hp_gcs_csd_d2_000_4_Tpg3Sl8OfMUbtm4rFv_mqPSeSXAqB&nodeId=Tpg3Sl8OfMUbtm4rFv&qid=1727282641613&sr=4" target="_blank">click here</a> or <a href="https://www.amazon.co.uk/gp/help/customer/display.html" target="_blank">contact Amazon Support</a>. By clicking on these links, you will be redirected to an external website.</Trans>
                                </span>
                            </div>
                        </div>
                    </>,
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        return isShowingProductSelection(values, orderEntryState, currentCountry) && values?.problem_1 && values?.problem_2 && !!orderEntryState?.selectedCategoryProduct && orderEntryState?.selectedPurchaseDate?.id === 'lastYear';
                    },
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <div className={'flex justify-center items-center w-full mt-6'}>
                            <div className={"py-6 px-9 rounded-2xl shadow-lg min-w-lg text-center bg-red-100"}>
                                <h3 className={'h3 text-center'}>
                                    <Trans i18nKey="orderEntry.outOfScope.message">Sorry, device with this problem are not currently eligible; we are working to increase the problems eligible for repair. At this time you need to contact Amazon Support. By clicking on this link you will be redirected to an external website.</Trans>
                                </h3>
                                <a className={'underline text-black mt-1.5 text-sm'} href={'https://www.amazon.co.uk/gp/help/customer/display.html'} target={'_blank'}>
                                    https://www.amazon.co.uk/gp/help/customer/display.html
                                </a>
                            </div>
                        </div>
                    </>,
                    "conditionFunction": (values, orderEntryState, currentCountry) => {
                        return isShowingProductSelection(values, orderEntryState, currentCountry) && values?.problem_1 && values?.problem_2 && !!orderEntryState?.selectedCategoryProduct && orderEntryState?.selectedPurchaseDate?.id !== 'lastYear';
                    },
                },
            ],
        },
        {
            "heading": <Trans i18nKey="orderEntry.chooseADevice">Choose a device</Trans>,
            // "description": <Trans i18nKey={"orderEntry.description"}>Your device is not behaving as you expect? <a href={"https://b2x.com/"} title={'B2X'} target={'_blank'}>B2X</a> support you from here to provide a solution quickly. Please complete the form below and we will get back to you to resolve the situation.</Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 className={'mt-9'}><Trans i18nKey={'orderEntry.identifyAmazonProduct'}>Identify your Amazon product</Trans></h2>
                        <h3><Trans i18nKey={'orderEntry.enterSerialNumber'}>Enter the serial number of your Amazon product</Trans></h3>
                    </>,
                },
                {
                    "component": "serialnumber",
                    "size": "full",
                    "required": true,
                    "validateSerialNumber": value => /^.{16}$/.test(value) ? undefined : <Trans i18nKey="serialNumber.write16chars">You have to provide exactly 16 characters</Trans>,
                    "uppercase": true,
                    "doNotShowConfirmDevice": true,
                },
                {
                    "component": "confirmdevice",
                    "conditionFunction": (values, orderEntryState) => validProblem(values, orderEntryState) && !!orderEntryState?.serialNumber?.product,
                },
            ],
            "id": "serialnumber",
            "noNextButton": true,
            "conditionFunction": (values, orderEntryState, currentCountry) => validProblem(values, orderEntryState) && !isShowingProductSelection(values, orderEntryState, currentCountry),
        },
        {
            "heading": <Trans i18nKey="orderEntry.repairModality">Repair Modality</Trans>,
            "description": <Trans i18nKey="orderEntry.upload-documents.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "id": "repairModality",
            "fields": [
                {
                    "size": "full",
                    "name": "margin",
                    "component": "callback",
                    "callback": (values, orderEntryState) => {
                        return <>
                            <div className={'mt-8'}>
                                <h2><Trans i18nKey="orderEntry.repairModality">Repair Modality</Trans></h2>
                            </div>
                        </>},
                },
                {
                    "size": "full",
                    "component": "requesttypeselect",
                    "doNotResetForm": true,
                },
                // {
                //     "size": "full",
                //     "component": "devicewidget",
                //     "conditionFunction": (values, orderEntryState) => values.requesttype === 'rma',
                // },
                {
                    "size": "full",
                    "component": "devicewidget",
                    "priceType": "serviceProduct",
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'oow-repair',
                    "style": "alternative",
                },
                {
                    "size": "full",
                    "component": "self_repair_instructions",
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'self_repair',
                    "displayFilesOnly": true,
                },
                ({ pageProps }) => ({
                    "size": "full",
                    "component": "selfrepairproductselect",
                    "maxQuantity": pageProps?.maxQuantity ?? 10,
                    "hideProductDetailsButton": true,
                    "hideUnavailableContactLink": true,
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'self_repair',
                }),
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values, orderEntryState) => {
                        const selectedProduct = orderEntryState && orderEntryState.products && orderEntryState.products.find(item => String(item.id) === product)
                            || orderEntryState?.serialNumber?.product;
                        const priceMax = formatCurrency(selectedProduct?.price?.priceGross + 100, selectedProduct?.price?.currency);
                        return <>
                            <p className='bg-white gap-3 rounded-lg p-6 b2x-shadow-md border border-2 border-secondary-900'>
                                <Trans
                                    i18nKey={'orderEntry.price.disclaimer'}
                                    priceMax={priceMax}
                                >
                                    * <b>Initial Repair Fee shown is for the diagnostics and transport services only.</b> Once we have received and confirmed the issue with your device we will confirm the additional Device Repair Fee to fix this issue. <b>Additional Device Repair Fee will be between £0 and {{priceMax}}.</b> You will be requested to approve and pay this cost before we proceed to repair your device.
                                </Trans>
                            </p>
                        </>;
                    },
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'oow-repair' && !!orderEntryState.serialNumber?.serviceProduct,
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values, orderEntryState) => {
                        const selectedProduct = orderEntryState && orderEntryState.products && orderEntryState.products.find(item => String(item.id) === product)
                            || orderEntryState?.serialNumber?.product;
                        const priceMax = formatCurrency(selectedProduct?.price?.priceGross + 100, selectedProduct?.price?.currency);
                        return <>
                            <p className='bg-white gap-3 rounded-lg p-6 b2x-shadow-md border border-2 border-secondary-900'>
                                <Trans
                                    i18nKey={'orderEntry.price.disclaimerPrepaidRepair'}
                                    priceMax={priceMax}
                                >
                                    * Repair Fee shown is for the diagnostics, transport and repair services.
                                </Trans>
                            </p>
                        </>;
                    },
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'oow-repair' && !orderEntryState.serialNumber?.serviceProduct,
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3><Trans i18nKey={'orderEntry.problemImage'}>Images of defects</Trans></h3>
                        <p><Trans i18nKey={'orderEntry.problemImage.description'}>Please upload pictures showing the defects where possible. You can upload JPG, PNG or PDF files up to 20 MB size.</Trans></p>
                    </>,
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'oow-repair',
                },
                {
                    "size": "full",
                    "component": "dropzoneform",
                    "type": "problem",
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'oow-repair',
                },
                {
                    "size": "full",
                    "name": "problem_description",
                    "label": <Trans i18nKey="serialNumber.problemDescription">Problem description</Trans>,
                    "multiline": true,
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'oow-repair',
                }
            ],
            "conditionFunction": (values, orderEntryState) => {
                return true;
                const product = orderEntryState.selectedProduct;
                const validProblem = values.problem_1 && values.problem_2;

                return ( product && validProblem && (values.serialnumber) );
            }
        },
        {
            "heading": <Trans i18nKey="orderEntry.yourDetails">Your Details</Trans>,
            "description": <Trans i18nKey="orderEntry.addressContact.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "id": "address",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values, orderEntryState) => {
                        const product = orderEntryState.selectedProduct;
                        return <><DeviceWidget  values={values} hideBadge={values.requesttype === 'self_repair'} />
                        </>},
                },
                ({ values, form }) => ({
                    size: "full",
                    component: "shoppingcart",
                    products: values.products,
                    transportProductId: values.transport_product_id,
                    onChangeTransportProduct: (transportProduct) => form.change("transport_product_id", transportProduct.id),
                    onRemoveProduct: (product) => form.change("products", values.products?.filter(p => p?.id !== product.id) ?? []),
                    onUpdateProductQuantity: (productId, amount) => form.change("products", values.products?.map(p => p?.id === productId ? { ...p, amount } : p) ?? []),
                    className: "b2x-shadow-md bg-white p-8 mt-4",
                    conditionFunction: (values, orderEntryState) => values.requesttype === 'self_repair',
                }),
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.addressContact.long'}>Contact and Address Details</Trans></h2>
                    </>,
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3 style={{ marginBottom: 0}}><Trans i18nKey={'queueDetail.contact'}>Contact</Trans></h3>
                    </>,
                },
                {
                    "name": "name",
                    "label": <Trans i18nKey="orderEntry.addressContact.enduserName">Name</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.enduserName">Name</Trans>,
                    "size": "full",
                    "type": "text",
                    "required": true,
                },
                {
                    "name": "email",
                    "label": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
                    "size": "half",
                    "type": "email",
                    "required": true,
                },
                {
                    "name": "phone",
                    "label": <Trans i18nKey="orderEntry.addressContact.phone">Phone</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.phoneNumber">Phone number</Trans>,
                    "size": "half",
                    "type": "phoneinput",
                    "required": true,
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3 style={{ marginBottom: 0}}><Trans i18nKey={'queueDetail.address'}>Address</Trans></h3>
                    </>,
                },
                {
                    "size": "full",
                    "component": "addressautocomplete"
                },
                {
                    "name": "zip",
                    "label": <Trans i18nKey="orderEntry.addressContact.zip">ZIP</Trans>,
                    "size": "half",
                    "required": true,
                    "validatetype": "api",
                    "validationRoute": route("order.validateZip"),
                },
                {
                    "name": "state",
                    "label": <Trans i18nKey="orderEntry.addressContact.state">State</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.country.placeholder">Please choose</Trans>,
                    "size": "half",
                    "type": "select",
                    "options": getUsStates().map(item => (
                        {
                            "value": item.abbreviation,
                            "label": `${item.abbreviation} - ${item.name}`
                        }
                    )),
                    "required": true,
                    "conditionFunction": (values, orderEntryState, currentCountry,) => currentCountry === 'US',
                },
                {
                    "name": "state",
                    "label": <Trans i18nKey="orderEntry.addressContact.province">Province</Trans>,
                    "size": "half",
                    "required": true,
                    "conditionFunction": (values, orderEntryState, currentCountry,) => currentCountry === 'IT',
                },
                {
                    "name": "city",
                    "label": <Trans i18nKey="orderEntry.addressContact.city">City</Trans>,
                    "size": "half",
                    "required": true,
                },
                {
                    "name": "country_id",
                    "label": <Trans i18nKey="orderEntry.addressContact.country">Country</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.country.placeholder">Please choose</Trans>,
                    "size": "half",
                    "type": "select",
                    "options": [
                        {
                            "value": "de",
                            "label": <Trans i18nKey="orderEntry.addressContact.germany">Germany</Trans>
                        },
                        {
                            "value": "ch",
                            "label": <Trans i18nKey="orderEntry.addressContact.switzerland">Switzerland</Trans>
                        }
                    ],
                    "required": true,
                    "onlyCurrentCountry": true,
                },
                {
                    "name": "deviating_invoice_address",
                    "label": <Trans i18nKey="orderEntry.deviating_invoice_address">Different billing address</Trans>,
                    "size": "full",
                    "type": "checkbox",
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3><Trans i18nKey={'orderEntry.invoice_address'}>Billing address</Trans></h3>
                        <p><Trans i18nKey={'orderEntry.invoice_address.description'}>Please fill in the address that will be displayed on the invoice.</Trans></p>
                    </>,
                    "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
                },
                {
                    "name": "invoice_name",
                    "label": <Trans i18nKey="orderEntry.addressContact.name">Name</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.name">Name</Trans>,
                    "size": "full",
                    "type": "text",
                    "required": true,
                    "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
                },
                {
                    "size": "full",
                    "component": "addressautocomplete",
                    "prefix_name": "invoice_",
                    "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
                },
                {
                    "name": "invoice_zip",
                    "label": <Trans i18nKey="orderEntry.addressContact.zip">ZIP</Trans>,
                    "size": "half",
                    "required": true,
                    "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
                },
                {
                    "name": "invoice_state",
                    "label": <Trans i18nKey="orderEntry.addressContact.state">State</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.country.placeholder">Please choose</Trans>,
                    "size": "half",
                    "type": "select",
                    "options": getUsStates().map(item => (
                        {
                            "value": item.abbreviation,
                            "label": `${item.abbreviation} - ${item.name}`
                        }
                    )),
                    "required": true,
                    "conditionFunction": (values, orderEntryState, currentCountry,) => currentCountry === 'US' && values.deviating_invoice_address,
                },
                {
                    "name": "invoice_state",
                    "label": <Trans i18nKey="orderEntry.addressContact.province">Province</Trans>,
                    "size": "half",
                    "required": true,
                    "conditionFunction": (values, orderEntryState, currentCountry,) => currentCountry === 'IT' && values.deviating_invoice_address,
                },
                {
                    "name": "invoice_city",
                    "label": <Trans i18nKey="orderEntry.addressContact.city">City</Trans>,
                    "size": "half",
                    "required": true,
                    "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
                },
                {
                    "name": "invoice_country_id",
                    "label": <Trans i18nKey="orderEntry.addressContact.country">Country</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.addressContact.country.placeholder">Please choose</Trans>,
                    "size": "half",
                    "type": "select",
                    "options": [
                        {
                            "value": "de",
                            "label": <Trans i18nKey="orderEntry.addressContact.germany">Germany</Trans>
                        },
                        {
                            "value": "ch",
                            "label": <Trans i18nKey="orderEntry.addressContact.switzerland">Switzerland</Trans>
                        }
                    ],
                    "required": true,
                    "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                return values.requesttype && orderEntryState?.serialNumber?.product && validProblem(values, orderEntryState) && (values.requesttype === 'self_repair' && hasProducts(values.products) || values.requesttype === 'oow-repair');
            },
        },
        {
            "heading": <Trans i18nKey="common.payment">Payment</Trans>,
            "description": <Trans i18nKey="orderEntry.termsandconditions.description"></Trans>,
            "id": "terms",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values, orderEntryState) => {
                        const product = orderEntryState.selectedProduct;
                        return <><DeviceWidget  values={values} hideBadge={values.requesttype === 'self_repair'} />
                        </>},
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.verifyAccountToPay'}>Verify your account to pay</Trans></h2>
                    </>,
                },
                {
                    "size": "full",
                    "component": "verify_phone_number"
                },
                {
                    "name": "terms_of_service",
                    "label": <Trans i18nKey="orderEntry.termsandconditions.label">I have read and accept the <a href={route('termsandconditions')} target={'_blank'}>Terms & Conditions</a> and the <a href={route('privacy')} target={'_blank'}>Privacy Statement</a></Trans>,
                    "size": "full",
                    "type": "checkbox",
                    "required": true
                },
                {
                    "name": "no_associated_parts",
                    "label": <Trans i18nKey="orderEntry.no_associated_parts.label">I acknowledge that I will not return my device with associated parts (for example USB cable or accessories), with the exception of Fire TV Stick products which are to be returned with the Fire TV Remote.</Trans>,
                    "size": "full",
                    "type": "checkbox",
                    "required": true,
                    "conditionFunction": (values, orderEntryState) => {
                        return values.requesttype === 'oow-repair';
                    },
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                const validAddress = values.name && values.city && validateEmailRegEx.test(values.email) && validatePhoneNumber.test(values.phone) && values.street && values.housenumber && values.zip && values.country_id;
                const validDeliveryAddress = !values.deviating_invoice_address || values.deviating_invoice_address && values.invoice_name && values.invoice_city && values.invoice_street && values.housenumber && values.invoice_zip && values.invoice_country_id;

                return validAddress && validDeliveryAddress && validProblem(values, orderEntryState);
            }
        }
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="orderEntry.confirmPay">Confirm & Pay</Trans>,
                    "id": "confirmsend",
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": (values, orderEntryState) => {
                        const validAddress = values.name && values.city && validateEmailRegEx.test(values.email) && validatePhoneNumber.test(values.phone) && values.street && values.housenumber && values.zip && values.country_id;

                        return validAddress && validProblem(values, orderEntryState) && values.terms_of_service && (values.requesttype === 'self_repair' || values.no_associated_parts) && orderEntryState?.verificationCodeResponse && (values.requesttype === 'self_repair' && hasProducts(values.products) || values.requesttype === 'oow-repair')
                    }
                }
            ]
        }
    ]
}
